import React, { useState } from 'react';
import { CheckCircle2, Loader2, AlertCircle, Phone, Mail, Clock } from 'lucide-react';
import { services, site } from '../data/site';
type Status = 'idle' | 'submitting' | 'success' | 'error';
export function QuoteForm() {
  const [status, setStatus] = useState<Status>('idle');
  const [name, setName] = useState('');
  const [contact, setContact] = useState('');
  const [service, setService] = useState(services[0].id);
  const [details, setDetails] = useState('');
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!name.trim() || !contact.trim()) {
      setStatus('error');
      return;
    }
    setStatus('submitting');
    window.setTimeout(() => setStatus('success'), 900);
  };
  return <section id="quote" className="bg-[#FFD84D] py-20 lg:py-28" data-id="element-133" data-mp="2xx1ti3tarqhc">
      <div className="mx-auto grid w-full max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-[1fr_1fr] lg:items-center" data-id="element-134" data-mp="3bv8h8r4j8a3a">
        <div data-id="element-135" data-mp="36x72gie52wxm">
          <h2 className="text-4xl font-black leading-[1.02] tracking-tight text-[#0B1B2B] sm:text-5xl lg:text-6xl" data-id="element-136" data-mp="36t9ixvnng3d7">
            Get a flat price,
            <br data-id="element-137" data-mp="3lm1m8lxdkas5" />
            usually the same day.
          </h2>
          <p className="mt-5 max-w-lg text-lg text-[#0B1B2B]/80" data-id="element-138" data-mp="3qlxpuk25u076">
            Tell us what you need cleaned. We'll send one all-in number — no site visit
            required for most homes and storefronts.
          </p>
          <ul className="mt-8 space-y-3" data-id="element-139" data-mp="3hq81yq298bo">
            <li className="flex items-center gap-3 text-base font-bold text-[#0B1B2B]" data-id="element-140" data-mp="3gyaiicwl0ir">
              <Phone className="h-5 w-5" aria-hidden="true" data-id="element-141" data-mp="8eqdq8j00929" />
              <a href={`tel:${site.phone.replace(/[^0-9]/g, '')}`} className="underline-offset-4 hover:underline" data-id="element-142" data-mp="d6hvbtk6f4g9">
                {site.phone}
              </a>
            </li>
            <li className="flex items-center gap-3 text-base font-bold text-[#0B1B2B]" data-id="element-143" data-mp="m7psu9evc19a">
              <Mail className="h-5 w-5" aria-hidden="true" data-id="element-144" data-mp="m5v4sm8avt0z" />
              <a href={`mailto:${site.email}`} className="underline-offset-4 hover:underline" data-id="element-145" data-mp="r7kkif6gwuve">
                {site.email}
              </a>
            </li>
            <li className="flex items-center gap-3 text-base font-bold text-[#0B1B2B]" data-id="element-146" data-mp="2j8lumpk89cc8">
              <Clock className="h-5 w-5" aria-hidden="true" data-id="element-147" data-mp="2wzqmh5hct0c0" />
              {site.hours}
            </li>
          </ul>
        </div>

        <div className="rounded-[2rem] border-4 border-[#0B1B2B] bg-[#FFFDF6] p-7 shadow-[10px_10px_0_0_#0B1B2B] sm:p-9" data-id="element-148" data-mp="2s8s2nvx5pk40">
          {status === 'success' ? <div className="flex min-h-[22rem] flex-col items-center justify-center text-center" data-id="element-149" data-mp="36zr84y2p3sjd">
              <CheckCircle2 className="h-14 w-14 text-[#16A34A]" aria-hidden="true" data-id="element-150" data-mp="3216c7auh7v0q" />
              <h3 className="mt-5 text-2xl font-black text-[#0B1B2B]" data-id="element-151" data-mp="3fwid5zz86hq3">Request received</h3>
              <p className="mt-3 max-w-sm text-base text-[#0B1B2B]/70" data-id="element-152" data-mp="3b0bacg24lmcd">
                Thanks, {name.split(' ')[0] || 'there'} — we'll get back to you with your
                flat price shortly, usually within a few hours.
              </p>
              <button type="button" onClick={() => {
            setStatus('idle');
            setName('');
            setContact('');
            setDetails('');
          }} className="mt-7 rounded-full border-2 border-[#0B1B2B] px-6 py-3 text-sm font-extrabold text-[#0B1B2B] hover:bg-[#0B1B2B]/5" data-id="element-153" data-mp="3s8c51yl6t73d">
                Send another request
              </button>
            </div> : <form onSubmit={handleSubmit} noValidate className="space-y-5" data-id="element-154" data-mp="3eh5y5hfkw76g">
              <h3 className="text-2xl font-black text-[#0B1B2B]" data-id="element-155" data-mp="3efcso5gpbt01">Request a free quote</h3>

              {status === 'error' && <p role="alert" className="flex items-start gap-2 rounded-xl border-2 border-[#B91C1C] bg-[#FEE2E2] px-4 py-3 text-sm font-bold text-[#B91C1C]" data-id="element-156" data-mp="34iq5ha0wkpuu">
                  <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-157" data-mp="12s6ec5wba7qf" />
                  Please add your name and a phone number or email so we can reach you.
                </p>}

              <div data-id="element-158" data-mp="937703xm0seh">
                <label htmlFor="q-name" className="block text-sm font-extrabold text-[#0B1B2B]" data-id="element-159" data-mp="92xhsike2p9u">
                  Your name
                </label>
                <input id="q-name" value={name} onChange={e => setName(e.target.value)} required className="mt-2 w-full rounded-xl border-2 border-[#0B1B2B] bg-white px-4 py-3 text-base text-[#0B1B2B] outline-none focus:ring-4 focus:ring-[#7FD8FF]" placeholder="Jordan Blake" data-id="element-160" data-mp="3v9vrbgnl1us9" />
              </div>

              <div data-id="element-161" data-mp="3cjxigybynxnk">
                <label htmlFor="q-contact" className="block text-sm font-extrabold text-[#0B1B2B]" data-id="element-162" data-mp="3ckfq0r42pyas">
                  Phone or email
                </label>
                <input id="q-contact" value={contact} onChange={e => setContact(e.target.value)} required className="mt-2 w-full rounded-xl border-2 border-[#0B1B2B] bg-white px-4 py-3 text-base text-[#0B1B2B] outline-none focus:ring-4 focus:ring-[#7FD8FF]" placeholder="(555) 123-4567" data-id="element-163" data-mp="33hobujjtcofg" />
              </div>

              <div data-id="element-164" data-mp="1wylr3hmnq2gw">
                <label htmlFor="q-service" className="block text-sm font-extrabold text-[#0B1B2B]" data-id="element-165" data-mp="1wxu9xbtt47a5">
                  What do you need cleaned?
                </label>
                <select id="q-service" value={service} onChange={e => setService(e.target.value)} className="mt-2 w-full rounded-xl border-2 border-[#0B1B2B] bg-white px-4 py-3 text-base text-[#0B1B2B] outline-none focus:ring-4 focus:ring-[#7FD8FF]" data-id="element-166" data-mp="14caroaase7lo">
                  {services.map(item => <option key={item.id} value={item.id} data-id="element-167" data-mp="ljzvezan17wj">
                      {item.title}
                    </option>)}
                  <option value="multiple" data-id="element-168" data-mp="di8zej1hbphv">Multiple services</option>
                </select>
              </div>

              <div data-id="element-169" data-mp="9gnsrffjg7g4">
                <label htmlFor="q-details" className="block text-sm font-extrabold text-[#0B1B2B]" data-id="element-170" data-mp="n9lt7g6u8pqj">
                  Anything we should know? <span className="font-bold text-[#0B1B2B]/50" data-id="element-171" data-mp="ibtqdr4nnj7k">(optional)</span>
                </label>
                <textarea id="q-details" value={details} onChange={e => setDetails(e.target.value)} rows={3} className="mt-2 w-full resize-none rounded-xl border-2 border-[#0B1B2B] bg-white px-4 py-3 text-base text-[#0B1B2B] outline-none focus:ring-4 focus:ring-[#7FD8FF]" placeholder="Two-story home, about 24 windows, second-story access from the deck." data-id="element-172" data-mp="3qrn6w5yzkuom" />
              </div>

              <button type="submit" disabled={status === 'submitting'} className="flex w-full items-center justify-center gap-2 rounded-full border-2 border-[#0B1B2B] bg-[#0B1B2B] px-6 py-4 text-base font-extrabold text-[#FFFDF6] transition hover:-translate-y-0.5 disabled:translate-y-0 disabled:opacity-70" data-id="element-173" data-mp="1ayo9ajltqaix">
                {status === 'submitting' && <Loader2 className="h-5 w-5 animate-spin" aria-hidden="true" data-id="element-174" data-mp="2ovra9z6msl2i" />}
                {status === 'submitting' ? 'Sending…' : 'Send my request'}
              </button>
              <p className="text-center text-xs font-bold text-[#0B1B2B]/50" data-id="element-175" data-mp="3gm5ef3ouej0z">
                No spam, no pushy follow-ups. Just your price.
              </p>
            </form>}
        </div>
      </div>
    </section>;
}